<template>
  <div class="content-wrapper">
    <section class="content">
      <section style="margin-bottom: 1%" v-if="$store.getters.hasFunction('payable_create')">
        <a-button type="primary" @click="createPaymentNote">
          <i class="icon iconfont icon-new" style="margin-right: 5px"></i>
          {{ $t('新增付款单') }}
        </a-button>
      </section>
      <div class="form-content">
        <a-row :gutter="16" style="margin-top: 15px">
          <a-col :span="6">
            <CommonSelect
              :isBu="true"
              :list="$store.state.settlementBuList"
              :placeholder="$t('结算组织')"
              :code.sync="formData.businessUnitCode"
              @change="searchHandle(1)"
            />
          </a-col>
          <a-col :span="6">
            <a-input
              allow-clear
              v-model.trim="formData.noteSn"
              :placeholder="$t('请输入付款单号')"
            />
          </a-col>
          <a-col :span="6">
            <DateRangePicker
              id="requestTime"
              :needhms="false"
              @get_date="chooseRequestTime"
              :placeholder="$t(`请款时间`)"
              :start-time="formData.applyTimeStart"
              :end-time="formData.applyTimeEnd"
            />
          </a-col>
          <a-col :span="6">
            <CommonQuerySelect
              api="queryPurchaseSupplierList"
              :params="{
                status: 1,
              }"
              :placeholder="$t(`收款组织`)"
              :code.sync="formData.payeeCode"
              :name.sync="formData.payeeName"
              valueName="supplier_code"
              labelName="supplier_name"
            />
          </a-col>
          <a-col :span="6">
            <SelectDocumentType :docType="docType" :code.sync="formData.orderType" />
          </a-col>
          <a-col :span="6">
            <a-select
              v-model="formData.needGenerateVoucher"
              allow-clear
              :placeholder="$t('能否生成凭证')"
              style="width: 100%"
            >
              <a-select-option :value="1">{{ $t('需要') }}</a-select-option>
              <a-select-option :value="0">{{ $t('不需要') }}</a-select-option>
            </a-select>
          </a-col>
          <a-col :span="6">
            <a-select
              v-model="formData.voucherGenerated"
              allow-clear
              :placeholder="$t('已生成凭证')"
              style="width: 100%"
            >
              <a-select-option :value="1">{{ $t('是') }}</a-select-option>
              <a-select-option :value="0">{{ $t('否') }}</a-select-option>
            </a-select>
          </a-col>
        </a-row>
        <a-row :gutter="16" class="mt10">
          <a-col :span="6">
            <a-button @click="searchHandle(1)" class="btnBgc">
              <i class="iconfont" style="margin-right: 5px">&#xe647;</i>
              {{ $t(`查询`) }}
            </a-button>
            <a-button @click="reset">
              <a-icon type="redo" />
              {{ $t(`重置`) }}
            </a-button>
          </a-col>
        </a-row>
      </div>

      <CommonTable
        ref="commonTable"
        class="mt10"
        :showSelect="true"
        :selectedRowKeys.sync="selectedRowKeys"
        :selectedRows.sync="selectedRows"
        :columns.sync="paymentNoteColumns"
        :data-source="paymentNoteData"
        :statusList="payment_note_status"
        rowKey="id"
        :scroll="{ x: 'max-content' }"
        :loading="loading"
        :total="total"
        @select="onSelectChange"
        @search="queryPaymentNoteList"
      >
        <template v-slot:header>
          <div class="flex-ct">
            <OperateBtn
              api="operateDoc"
              :text="$t('审核')"
              :params="{
                action: 'check',
                docType: docType,
                idList: selectedRowKeys,
              }"
              :disabled="selectedRows.length === 0"
              @success="searchHandle"
            />
            <OperateBtn
              class="ml10"
              :disabled="!selectedRowKeys.length"
              api="payPaymentNote"
              :text="$t('付款')"
              dateField="payTime"
              :dateLabel="$t('付款时间')"
              :params="{
                idList: selectedRowKeys,
              }"
              @success="searchHandle"
            />
            <VoucherBtn
              class="ml10"
              :docType="docType"
              :selectedRows="selectedRows"
              :disabled="selectedRows.length === 0"
              @close="searchHandle"
            />
          </div>
        </template>
        <template v-slot:paymentNoteSn="{ text, record }">
          <span class="text-link" @click="viewDetail(record)">{{ text }}</span>
        </template>
        <template v-slot:paymentAmount="{ text, record }">
          <span v-if="text">{{ text | currencySymbol(record.paymentCurrency) }}</span>
        </template>
      </CommonTable>
    </section>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
import http from '@/service/axios'
import api from '@/service/api'
import CommonTable from '@component/commonTable'
import DateRangePicker from '@component/dateRangePicker'
import VoucherBtn from '@component/voucherBtn'
import SelectDocumentType from '@component/selectDocumentType'
import { spaceToComma, convertKeysToCamelCase, fetchDocumentMappings } from '@/common'

export default {
  name: 'paymentNoteList',
  components: { CommonTable, DateRangePicker, VoucherBtn, SelectDocumentType },
  data() {
    return {
      docType: 'PaymentNote',
      formData: {
        noteSn: '',
        applyTimeStart: undefined,
        applyTimeEnd: undefined,
        orderType: undefined,
        needGenerateVoucher: undefined,
        voucherGenerated: undefined,
      },
      total: 0,
      loading: false,
      paymentNoteData: [],
      selectedRowKeys: [],
      selectedRows: [],
      mappings: {
        orderType: {},
        settlementMethod: {},
      },

      paymentNoteColumns: [
        {
          title: this.$t('付款组织'),
          dataIndex: 'businessUnitName',
          width: 120,
        },
        {
          title: this.$t('付款单号'),
          dataIndex: 'paymentNoteSn',
          width: 200,
          scopedSlots: { customRender: 'paymentNoteSn' },
        },
        {
          title: this.$t('单据类型'),
          dataIndex: 'orderType',
          width: 120,
          customRender: (text) => this.mappings.orderType[text] || text,
        },
        {
          title: this.$t('单据状态'),
          dataIndex: 'status',
          customRender: (text) => this.paymentNoteStatusMapping[text],
          width: 120,
        },
        {
          title: this.$t('记账日期'),
          dataIndex: 'accountingDate',
          width: 120,
          customRender: (text) => text?.split(' ')[0],
        },
        {
          title: this.$t('业务日期'),
          dataIndex: 'bizDate',
          width: 120,
          customRender: (text) => text?.split(' ')[0],
        },
        {
          title: this.$t('付款货币'),
          dataIndex: 'paymentCurrency',
          width: 120,
          customRender: (text) => this.currencyListMapping[text],
        },
        {
          title: this.$t('付款金额'),
          dataIndex: 'paymentAmount',
          scopedSlots: { customRender: 'paymentAmount' },
          width: 120,
        },
        {
          title: this.$t('往来单位类型'),
          width: 120,
          dataIndex: 'payeeType',
          customRender: (text) => this.$store.getters.contactTypeMapping[text],
        },
        {
          title: this.$t('往来单位名称'),
          width: 120,
          dataIndex: 'payeeName',
        },
        {
          title: this.$t('结算方式'),
          dataIndex: 'settlementMethodName',
          width: 120,
        },
        {
          title: this.$t('能否生成凭证'),
          dataIndex: 'needGenerateVoucher',
          width: 120,
          customRender: (text, record) => {
            const val = record.needGenerateVoucher ?? record.need_generate_voucher
            return val === 1 ? this.$t('需要') : val === 0 ? this.$t('不需要') : ''
          },
        },
        {
          title: this.$t('已生成凭证'),
          dataIndex: 'voucherGenerated',
          width: 120,
          customRender: (text) => (+text ? this.$t('是') : this.$t('否')),
        },
        {
          title: this.$t('凭证号'),
          dataIndex: 'voucherNo',
          width: 200,
        },
        {
          title: this.$t('备注'),
          dataIndex: 'remark',
          width: 170,
        },
        {
          title: this.$t('创建人'),
          dataIndex: 'createdUser',
          width: 120,
        },
      ],
    }
  },
  activated() {
    this.searchHandle()
    this.fetchMappings()
  },
  computed: {
    ...mapState(['payment_note_status', 'payment_note_type']),
    ...mapGetters(['paymentNoteStatusMapping', 'paymentNoteTypeMapping', 'currencyListMapping']),
    scrollHeight() {
      return window.innerHeight - 470
    },
  },
  methods: {
    ...mapMutations(['addPane']),
    async fetchMappings() {
      this.mappings = await fetchDocumentMappings(this.docType, ['orderType', 'settlementMethod'])
    },
    reset() {
      const mappings = this.mappings
      Object.assign(this.$data, this.$options.data.call(this))
      this.mappings = mappings
      this.searchHandle(1)
    },
    searchHandle(pageNo) {
      this.selectedRows = []
      this.selectedRowKeys = []
      this.$refs.commonTable.queryList(pageNo)
    },
    createPaymentNote() {
      this.$router.push({ name: 'paymentNoteDetail' })
    },
    chooseRequestTime(date) {
      this.formData.applyTimeStart = date.start_time
      this.formData.applyTimeEnd = date.end_time
    },
    async queryPaymentNoteList(params) {
      if (!this.formData.businessUnitCode) return
      const data = {
        ...this.formData,
        ...params,
      }
      let noteSn = spaceToComma(this.formData.noteSn)
      if (noteSn.includes(',')) {
        data.noteSnList = noteSn.split(',')
      } else if (noteSn) {
        data.noteSn = noteSn
      }
      this.loading = true
      const res = await http({
        type: 'post',
        url: api.getPaymentNoteList,
        data,
      })
      this.paymentNoteData = convertKeysToCamelCase(res.result.list) || []
      this.total = res.result.total
      this.loading = false
    },
    viewDetail(record) {
      this.addPane({
        view: 'payableManage/paymentNoteDetail/' + record.paymentNoteSn,
        name: 'detailSn',
        query: {
          id: record.id,
          sn: record.paymentNoteSn,
        },
        route: `/payableManage/paymentNoteDetail?id=${record.id}&sn=${record.paymentNoteSn}`,
      })
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
  },
}
</script>

<style lang="scss" scoped>
.btnBgc {
  background-color: #0088ff;
  color: #ffffff;
}
</style>
